__turbopack_context__.v({
  "errorFallback": "ErrorBoundary-module__6WW5aq__errorFallback",
  "errorMessage": "ErrorBoundary-module__6WW5aq__errorMessage",
  "headline": "ErrorBoundary-module__6WW5aq__headline",
  "tryAgainButton": "ErrorBoundary-module__6WW5aq__tryAgainButton",
});
